<figure class="fd-wrap" *ngIf="diagram">
  <figcaption class="fd-title" *ngIf="diagram.title">{{ diagram.title }}</figcaption>
  <div class="fd-grid">
    <div class="fd-row fd-header">
      <div class="fd-cell fd-string-label"></div>
      <div class="fd-cell fd-marker-head"></div>
      <div class="fd-cell fd-fret-label" *ngFor="let fret of fretColumns">{{ fret }}</div>
    </div>
    <div class="fd-row" *ngFor="let stringLabel of stringLabels; let si = index">
      <div class="fd-cell fd-string-label">{{ stringLabel }}</div>
      <div class="fd-cell fd-marker">{{ marker(si) }}</div>
      <div class="fd-cell fd-fret" *ngFor="let fret of fretColumns">
        <div class="fd-line"></div>
        <span class="fd-dot" *ngIf="hasDot(si, fret)">{{ label(si) }}</span>
      </div>
    </div>
  </div>
</figure>
